import { useState } from "react";
import useGlobal from "../../../util/Global";
import KriterModulBilesenlerComponent from "./KriterModulBilesenlerComponent";
import { useShareContext } from "./BasvuruContext";
import { Add } from "@mui/icons-material";
import { Button, colors, Container, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import useMessage from "../../../util/useMessagev2";
import KriterKomponentList from "./KriterKomponentList";
import { HeaderText } from "../../../menu/muiStyles";
import CutIconButton, { Colors } from "../../../ui/CutIconButton";

const KriterKomponentBilesenlerComponent = ({ modulId, kriterKomponent, moduleName }) => {

    const { t } = useGlobal();
    const [open, setOpen] = useState(false);
    const [selKomponentKriterler, setKomponentKriterler] = useState({});
    const { updateKomponentKriterler, KomponentZorunlu } = useShareContext();
    const [isInsert, setIsInsert] = useState(false);
    const message = useMessage();

    const handleKomponentDialog = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = async () => {
        // const zorunlu = await 

        setIsInsert(true);

        const result = await KomponentZorunlu({
            komponentId: kriterKomponent.id,
            komponentKriterler: [selKomponentKriterler],
            modulId: modulId
        });



        if (!result.isValid) {
            message.error(`${t("message.ZorunluAlanlarDoldurun")}`);
            console.log('Komponent Missing Columns ');
            console.log(result);
            setIsInsert(false);
            return;
        }
        updateKomponentKriterler({
            modulId: modulId,
            kriterKomponent: kriterKomponent.id,
            komponentKriterler: [selKomponentKriterler]
        });

        setOpen(false);
        setIsInsert(false);
    };

    // console.log(kriterKomponent);


    return <Container sx={{ paddingTop: 2 }} >
        <HeaderText>

            {moduleName}

            <CutIconButton
                icon={Add}
                color="primary"
                onClick={() => handleKomponentDialog()}
                style={{ marginLeft: 10 }}
                size="small"
                bgColor={colors.blueGrey[100]}
            />


        </HeaderText>


        <KriterKomponentList
            key={kriterKomponent.id}
            modulId={modulId}
            kriterKomponent={kriterKomponent.id}
        />

        {/* kriterKomponent */}
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>{kriterKomponent.display}</DialogTitle>
            <DialogContent>
                <KriterModulBilesenlerComponent
                    key={modulId}
                    modulId={modulId}
                    kriterKomponent={kriterKomponent.id}
                    setKomponentKriterler={setKomponentKriterler} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {t("button.cancel")}
                </Button>
                <Button onClick={handleSave} color="primary" variant="contained" disabled={isInsert}>
                    {t("button.save")}
                </Button>
            </DialogActions>
        </Dialog>
    </Container>
}

export default KriterKomponentBilesenlerComponent;